import axios from "../../axios/axios";
import { estadosCodigos } from "../services/gerarEdital";

export function formatarListaComE(listaFormatada) {
  if (listaFormatada.length === 0) return "";
  if (listaFormatada.length === 1) return listaFormatada[0];
  const inicio = listaFormatada.slice(0, -1).join(", ");
  const ultimo = listaFormatada[listaFormatada.length - 1];
  return `${inicio} e ${ultimo}`;
}

export const gerarTitulo = (base, lista, genero = "m") => {
  console.log('recebido', base, lista, genero)
  const plural = lista.length > 1;
  let executadoGender
  let artigo
  if (base == 'executado') {
    const genders = new Set(lista.map((e) => e.genero))
    genders.size == 2 ? executadoGender = "m" : executadoGender = [...genders][0]
    artigo = executadoGender === "f"
      ? (plural ? "das" : "da")
      : (plural ? "dos" : "do");
  } else {
    // Corrija aqui:
    let groupGender = "m";
    if (lista.length > 0) {
      const genders = new Set(lista.map((e) => e.genero || "m"));
      groupGender = genders.size === 1 ? [...genders][0] : "m";
    }
    artigo = groupGender === "f" ? (plural ? "das" : "da") : (plural ? "dos" : "do");
    genero = groupGender;
  }

  console.log(base)

  let palavra;
  if (base === "terceiro interessado") {
    palavra = genero === "f"
      ? (plural ? "terceiras interessadas" : "terceira interessada")
      : (plural ? "terceiros interessados" : "terceiro interessado");
  } else if (base === "executado") {
    const genders = new Set(lista.map((e) => e.genero));
    let executadoGender;
    executadoGender = genders.size === 2 ? "m" : [...genders][0];
    palavra = executadoGender === "f"
      ? (plural ? "executadas" : "executada")
      : (plural ? "executados" : "executado");
  } else if (base === "requerido") {
    palavra = genero === "f"
      ? (plural ? "requeridas" : "requerida")
      : (plural ? "requeridos" : "requerido");
  } else if (base === "credor") {
    palavra = genero === "f"
      ? (plural ? "credoras" : "credora")
      : (plural ? "credores" : "credor");
  } else {
    palavra = genero === "f"
      ? (plural ? `${base}as` : `${base}a`)
      : (plural ? `${base}es` : base);
  }

  console.log('palavra', palavra)

  return `${artigo} ${palavra}`;
};

export function numeroParaExtenso(valor) {
  const unidades = ["zero", "um", "dois", "três", "quatro", "cinco", "seis", "sete", "oito", "nove"];
  const especiais = ["dez", "onze", "doze", "treze", "quatorze", "quinze", "dezesseis", "dezessete", "dezoito", "dezenove"];
  const dezenas = ["", "", "vinte", "trinta", "quarenta", "cinquenta", "sessenta", "setenta", "oitenta", "noventa"];

  let n = parseInt(valor, 10);
  if (isNaN(n)) return "";

  if (n < 10) return `${unidades[n]} por cento`;
  if (n < 20) return `${especiais[n - 10]} por cento`;
  if (n < 100) {
    let dez = Math.floor(n / 10);
    let uni = n % 10;
    return `${dezenas[dez]}${uni ? " e " + unidades[uni] : ""} por cento`;
  }
  if (n === 100) return "cem por cento";
  return `${n} por cento`; // Para valores maiores, pode expandir a função
}

export function abreviarMes(mes) {
  const mapa = {
    janeiro: "Jan", fevereiro: "Fev", março: "Mar", abril: "Abr", maio: "Mai", junho: "Jun",
    julho: "Jul", agosto: "Ago", setembro: "Set", outubro: "Out", novembro: "Nov", dezembro: "Dez"
  };
  let abrev = mapa[mes?.toLowerCase()] || mes || "";
  if (abrev && typeof abrev === "string") {
    return abrev.charAt(0).toUpperCase() + abrev.slice(1).toLowerCase();
  }
  return abrev;
}



export function horarioParaExtenso(horario) {
  if (!horario) return "";
  const [h, m] = horario.split(":");
  if (!h || !m) return "";
  const horas = parseInt(h, 10);
  const minutos = parseInt(m, 10);
  let texto = "";
  if (horas > 0) texto += `${horas} hora${horas > 1 ? "s" : ""}`;
  if (minutos > 0) texto += `${texto ? " e " : ""}${minutos} minuto${minutos > 1 ? "s" : ""}`;
  return texto;
}

export function parseValor(valor) {
  if (!valor) return 0;
  // Remove R$, pontos e troca vírgula por ponto
  return parseFloat(
    valor.replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.')
  ) || 0;
}
export function formatarMoeda(valor) {
  return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}


export const getProcesso = async (processo, setVara, setForo, juiz, setJuiz, indicacao, setLotes, lotes, exequentes, setExequentes, setEstado) => {
  const key = processo.slice(15, 21)
  if (key.length == 6) {
    if (estadosCodigos[key]) {
      setEstado(estadosCodigos[key]?.sigla)
    }
  }
  if (processo?.trim()?.length == 25) {
    // const keys = Object.keys(formData || {});
    const found = indicacao.find(
      (ind) => ind?.processo?.trim() === processo?.trim(),
    );

    if (found) {
      setVara(found?.vara || '')
      setForo(found?.foro || '')
      setJuiz({ ...juiz, nome: found?.juizo })


      const { data } = await axios.get('/solicitacao/captacao/avaliacao/filter/many?processo=' + processo?.trim())

      const newData = {
        inscricao: [],
        matricula: [],
        cartorio: [],
      }

      if (data?.length) {
        data?.forEach((e) => {
          newData['matricula'] = [...newData['matricula'], e?.num_matricula]
          newData['cartorio'] = [...newData['cartorio'], e?.cartorio]
        })

        console.log(data[0])

        if (data[0].nomeSolicitante) {
          const copy = [...exequentes]
          copy[0].nome = data[0].nomeSolicitante
          copy[0].doc = data[0].documentoSolicitante
          setExequentes(copy)
        }
      }



      const { data: dadosAv } = await axios.get(`/avaliacao/relatorio?processo=${processo?.trim()}`);

      console.log(dadosAv)

      if (dadosAv?.length) {
        dadosAv?.forEach((e) => {
          newData['inscricao'] = [...newData['inscricao'], e?.inscricao_municipal]
        })
      }

      const copyLotes = [...lotes]



      for (let i = 0; i < newData.matricula.length; i++) {
        if (copyLotes[i]) {
          copyLotes[i].inscricao = newData.inscricao[i] || ''
          copyLotes[i].matricula = newData.matricula[i] || ''
          copyLotes[i].cartorio = newData.cartorio[i] || ''
        } else {
          copyLotes[i] = {
            ...copyLotes[i - 1],
            inscricao: newData.inscricao[i] || '',
            matricula: newData.matricula[i] || '',
            cartorio: newData.cartorio[i] || '',
          }
        }
      }

      setLotes(copyLotes)
    }
  }
}

// Função para converter número por extenso (valores em Reais e centavos)
function numeroParaExtensoCausa(valor) {
  const unidade = [
    "", "um", "dois", "três", "quatro", "cinco", "seis", "sete", "oito", "nove",
    "dez", "onze", "doze", "treze", "quatorze", "quinze", "dezesseis", "dezessete", "dezoito", "dezenove"
  ];
  const dezenas = ["", "", "vinte", "trinta", "quarenta", "cinquenta", "sessenta", "setenta", "oitenta", "noventa"];
  const centenas = ["", "cem", "cento", "duzentos", "trezentos", "quatrocentos", "quinhentos", "seiscentos", "setecentos", "oitocentos", "novecentos"];

  function parteInteiraParaExtenso(n) {
    if (n === 0) return "zero";
    if (n < 20) return unidade[n];
    if (n < 100) return dezenas[Math.floor(n / 10)] + (n % 10 !== 0 ? " e " + unidade[n % 10] : "");
    if (n < 1000) {
      const c = Math.floor(n / 100);
      const resto = n % 100;
      const centena = c === 1 && resto === 0 ? "cem" : centenas[c];
      return centena + (resto !== 0 ? " e " + parteInteiraParaExtenso(resto) : "");
    }
    if (n < 1000000) {
      const milhar = Math.floor(n / 1000);
      const resto = n % 1000;
      let milharTexto = milhar === 1 ? "mil" : parteInteiraParaExtenso(milhar) + " mil";
      return milharTexto + (resto !== 0 ? (resto < 100 ? " e " : ", ") + parteInteiraParaExtenso(resto) : "");
    }
    return "valor muito alto";
  }

  const reais = Math.floor(valor);
  const centavos = Math.round((valor - reais) * 100);

  const reaisTexto = reais === 1 ? "Real" : "Reais";
  const centavosTexto = centavos === 1 ? "centavo" : "centavos";

  let texto = parteInteiraParaExtenso(reais) + " " + reaisTexto;
  if (centavos > 0) {
    texto += " e " + parteInteiraParaExtenso(centavos) + " " + centavosTexto;
  }

  return texto;
}

// Função principal: formata número e escreve por extenso
export function formatarValorCompleto(valor) {
  const valorFormatado = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(valor);

  const valorExtenso = numeroParaExtensoCausa(valor);

  return `${valorFormatado} (${valorExtenso})`;
}

// Exemplo de uso
